import assign from 'lodash/assign';
import { fundingSourceEndNodes } from './endNode/funding-source/funding-source';
import { vendorEndNodes } from './endNode/vendor/vendor';
import { apiEndNode } from './endNode/api/api';
import { nestedEndNode } from './endNode/nested/nested';
import { nestedNode } from './nested/nested';

export const integration: {} = assign(
  {},
  fundingSourceEndNodes,
  vendorEndNodes,
  apiEndNode,
  nestedEndNode,
  nestedNode
);
